import React from 'react';
// Importez Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Importez les modules nécessaires (Pagination, Navigation, Autoplay)
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

// Importez les styles Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation'; // Assurez-vous d'importer les styles de navigation
import './Events.css'; // Assurez-vous que le chemin est correct

// Données mises à jour avec les chemins des images
const events = [
  {
    id: 1,
    type: 'À venir',
    date: '2025-05-12',
    title: 'Brunch Fermier du Dimanche',
    description: 'Un brunch complet avec des produits de la ferme, sur réservation uniquement.',
    imageSrc: '/images/g5.jpg' // Image ajoutée
  },
  {
    id: 2,
    type: 'Passé',
    date: '2025-04-14',
    title: 'Dégustation de fromages du printemps',
    description: 'Un moment convivial autour de nos nouveautés fromagères.',
    imageSrc: '/images/g6.jpg' // Image ajoutée
  },
  {
    id: 3,
    type: 'Prestations sur devis',
    // Pas de date spécifique pour ce type
    title: 'Soirée d’entreprise',
    description: 'Privatisation de l’espace pour vos événements pros avec buffet fermier.',
    imageSrc: '/images/g7.jpg' // Image ajoutée
  },
  {
    id: 4,
    type: 'Prestations sur réservation',
    // Pas de date spécifique pour ce type
    title: 'Brunch du marché',
    description: 'Tous les premiers dimanches du mois, réservez votre place pour un brunch artisanal.',
    imageSrc: '/images/g8.jpg' // Image ajoutée
  },
  // Si vous avez un 5ème événement, vous pouvez utiliser g9.jpg
  /*
  {
    id: 5,
    type: 'Autre Type',
    title: 'Atelier Fabrication Fromage',
    description: 'Apprenez les bases de la fabrication de fromage frais.',
    imageSrc: '/images/g9.jpg'
  },
  */
];

// Fonction pour formater la date ou retourner null
const formatDate = (dateString) => {
    if (!dateString) return null;
    try {
        // Utilisation de l'heure locale et formatage standard français
        return new Date(dateString).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    } catch (e) {
        console.error("Invalid date format:", dateString);
        return null; // Retourne null si la date est invalide
    }
};


function Events() {
  return (
    // Utilisons un ID si on veut pouvoir y lier depuis la Navbar, par exemple id="events"
    <section id="events" className="events-section">
      <div className="container">
        <h2 className="section-title">Nos Événements & Prestations</h2>
        <p className="section-subtitle">
          Participez à nos moments conviviaux ou faites appel à nous pour vos occasions spéciales.
        </p>

        {/* Remplace events-grid par Swiper */}
        <Swiper
          modules={[Pagination, Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={1} // Une slide par défaut sur mobile
          loop={true}
          autoplay={{
            delay: 4000, // Ajustez le délai de l'autoplay si vous le souhaitez
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation={true} // Active les flèches de navigation
          centeredSlides={false} // Les slides ne sont pas centrées par défaut
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          }}
          className="myEventsSwiper" // Nouvelle classe pour ce Swiper
        >
          {events.map((event) => {
            const formattedDate = formatDate(event.date);

            return (
              <SwiperSlide key={event.id}>
                <div className={`event-card event-${event.type.toLowerCase().replace(/\s+/g, '-')}`}>
                  <div className="event-image-container">
                    <img
                      src={event.imageSrc}
                      alt={`Illustration pour ${event.title}`}
                      className="event-image"
                      loading="lazy"
                    />
                    <span className="event-tag">{event.type}</span>
                  </div>
                  <div className="event-content">
                    {formattedDate && <p className="event-date">Le {formattedDate}</p>}
                    <h3 className="event-card-title">{event.title}</h3>
                    <p className="event-description">{event.description}</p>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Events;